import store from "@/store";
export class IppanSeibiService {

  // 車検用のラベルを一般整備用に変換する辞書
  // ※画面側で変換すると漏れや表記揺れのリスクがあるためここにまとめる。
  private labelDict: {[K in string]: string} = {
    // '車検': '', // 「車検」単体の変換は使用しない（作業、整備、削除と3パターンあるので）
    '車検種類': '作業種類',
    '車検中止': '作業中止',
    '車検の進行状況': '進行状況',
    '法定57項目整備代': '整備代',
    '車検代金': '整備代金',
    '車検を中止しますか？': '作業を中止しますか？',
    'データを保存して車検を終了します。よろしいですか？': 'データを保存して作業を終了します。よろしいですか？',
    '車検を再開する': '作業を再開する',
    '車検が開始されました。': '作業が開始されました。',
    '概算車検見積書': '概算見積書',
    '車検諸費用': '諸費用',
    '車検検査費用': '検査費用',
    '諸費用小計（①＋②＋③＋④）': '諸費用小計（①＋②）',
    '整備代・部品代⑤': '整備代・部品代③',
    '概算車検金額（①＋②＋③＋④＋⑤）': '概算金額（①＋②＋③）',
    '車検メニュー': '整備メニュー',
    '車検区分': '作業分類',
    '現車・法定57項目 整備代小計': '整備代小計',
    '現車・法定57項目検査の結果': '検査の結果',
  };
  // 2026/07/15 手数料/オプション、割引/クーポンの判断は共通関数では難しいので切り出しました 

  constructor() {
  }
  get isIppanSeibi(): boolean | null {
    return store.getters["FunctionSetting/isUseIppanSeibi"] 
      && store.getters["ReservationDetail/sknSeibiShubetsuKbn"] > 0;
  }

  getIppanSeibiLabel(shakenLabel: string): string {
    if (!this.labelDict[shakenLabel]) {
      window.console.error('getIppanSeibiLabel 未設定の単語', shakenLabel);
    }
    return this.isIppanSeibi ? this.labelDict[shakenLabel] : shakenLabel;
  }

}

